import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { useParams, useNavigate } from 'react-router-dom'; // Importa useNavigate
import { Card, ListGroup, Button } from 'react-bootstrap';
import { useLoading } from '../../components/LoadingContext'; 



const ShowMorePostulados = ({ onReload }) => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate(); // Inicializa useNavigate
  const { setLoading } = useLoading(); // Usar el contexto de carga

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Inicia la animación de carga
      try {
        let relationsArray = ['datosIdentificacion','EstadoCivil','Discapacidad','Disponibilidad','ExpLaboral','QuienVive','RolHogar','HorarioMañana','HorarioTarde','StatusBe'];
        const relations = relationsArray.join(',');
        const token = localStorage.getItem('token');
        const response = await axios.get(`/participantes-bolsa/${id}?with=${relations}`,{
          headers: {
              Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Detiene la animación de carga
      }
    };

    fetchData();
  }, [id, setLoading]);

  return (
    <div className="container my-5"> {/* Añadido margen superior */}
      <div className="row justify-content-center"> {/* Centra el contenido */}
        <div className="col-lg-9 col-md-8"> {/* Ajusta el tamaño de la tarjeta */}
          <Card className="p-4 shadow"> {/* Añadido padding y sombra */}
            <h1 className="mb-4 text-center">Detalles del Postulado V-{data?.datos_identificacion?.cedula_identidad}</h1> {/* Centrado el título */}
            <ListGroup variant="flush">
              <ListGroup.Item>Fecha de Postulacion: {data.created_at}</ListGroup.Item>
              <ListGroup.Item>Status Bolsa Empleo: {data?.status_be?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Cedula de identidad: {data?.datos_identificacion?.cedula_identidad}</ListGroup.Item>
              <ListGroup.Item>Nombres: {data?.datos_identificacion?.nombres}</ListGroup.Item>
              <ListGroup.Item>Apellidos {data?.datos_identificacion?.apellidos}</ListGroup.Item>
              <ListGroup.Item>Estado Civil {data?.estado_civil?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Discapacidad: {data?.discapacidad?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Disponibilidad: {data?.disponibilidad?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Entorno Familiar: {data?.entorno_familiar}</ListGroup.Item>
              <ListGroup.Item>Fortalezas: {data.fortalezas}</ListGroup.Item>
              <ListGroup.Item>Experiecia: {data?.exp_laboral?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Aspectos Mejorables: {data.aspectos_mejorables?.descripcion}</ListGroup.Item>
              <ListGroup.Item>¿Con quien vive?: {data.quien_vive?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Rol de hogar: {data?.rol_hogar?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Telefono Casa: {data.tlf_casa}</ListGroup.Item>
              <ListGroup.Item>Telefono Celular: {data.tlf_celular}</ListGroup.Item>
              <ListGroup.Item>Email: {data.email}</ListGroup.Item>
              <ListGroup.Item>Sector: {data.sector}</ListGroup.Item>
              <ListGroup.Item>Horario de mañana: {data?.horario_mañana?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Horario de tarde: {data.horario_tarde?.descripcion}</ListGroup.Item>
              <ListGroup.Item>Observaciones{data.observaciones}</ListGroup.Item>
              <ListGroup.Item>Relevante: {data.relevante}</ListGroup.Item>
              <ListGroup.Item>Comentario: {data.comentario}</ListGroup.Item>
              <ListGroup.Item>Cargo Aspirante: {data.cargo_asp}</ListGroup.Item>
              <ListGroup.Item>Apariencia {data.apariencia}</ListGroup.Item>
              <ListGroup.Item>Oral: {data.oral}</ListGroup.Item>
              <ListGroup.Item>Iniaciativa: {data.iniciativa}</ListGroup.Item>
              <ListGroup.Item>Liderazgo: {data.liderazgo}</ListGroup.Item>
              <ListGroup.Item>Madurez: {data.madurez}</ListGroup.Item>
              <ListGroup.Item>Relaciones: {data.relaciones}</ListGroup.Item>
              <ListGroup.Item>Elegible: {data.elegible}</ListGroup.Item>

            </ListGroup>
  
            <div className="text-center mt-4">
            <Button
                variant="secondary"
                onClick={() => navigate(-1)}  // Esto navega a la última página
                >
                Volver
                </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
  
    };

export default ShowMorePostulados;
